import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { IndicationGroup } from '@app/models/indication';
import { SearchIndicationsModel } from '@app/models/search-indications';
import { AccountService } from '@app/services/account-service';
import { SharedService } from '@app/services/shared.service';

@Component({
  selector: 'app-indication-group',
  templateUrl: './indication-group.component.html',
  styleUrls: ['./indication-group.component.css']
})
export class IndicationGroupComponent implements OnInit {

  @Input() indicationGroup: IndicationGroup;
  selectedSearchIndication: SearchIndicationsModel;
  
  allIndications: IndicationGroup[] = [];
  limitsInputIndications: string[] = ['cReactiveProtein', 'bmi', 'waistCircumference', 'creatinine', 'eosinophilsNumber', 'hemoglobin'];
  criteriaInputIndications: string[] = ['chronicBronchitis', 'smoking'];
  checkboxTreeviewIndications: string[] = ['arthritis', 'depression'];
  isDemoUser = false;

  constructor(
    private sharedService: SharedService,
    private cdRef: ChangeDetectorRef,
    private accountService: AccountService
    ) { }

  ngOnInit() {
    const account = this.accountService.accountValue;
    if (account) {
      this.isDemoUser = account.roles.includes(103);
    }

    this.sharedService.allIndications.subscribe(data => {
      if (data) {
        this.allIndications = data;
        this.cdRef.detectChanges();
      }
    });

    this.sharedService.selectedSearchIndication.subscribe(selection => {
      if (selection) {
        this.selectedSearchIndication = selection;
      } else {
        this.selectedSearchIndication = undefined;
      }
    });
  }

  indicationSelectionChange(event): void {
    const matchingGroupIndex = this.allIndications.findIndex(i => i.name === this.indicationGroup.name);
    this.allIndications[matchingGroupIndex] = this.indicationGroup;
    this.sharedService.setAllIndications(this.allIndications);
  }

  criteriaInput(indicationName: string): boolean {
    if (this.criteriaInputIndications.includes(indicationName)) {
      return true;
    }
    return false;
  }

  limitsInput(indicationName: string): boolean {
    if (this.limitsInputIndications.includes(indicationName)) {
      return true;
    }
    return false;
  }

  checkboxTreeview(indicationName: string): boolean {
    if (this.checkboxTreeviewIndications.includes(indicationName)) {
      return true;
    }
    return false;
  }

}
